import {
  GlobalComponentsScreenInterface,
  ILayout,
  LayoutTypeIds,
} from 'src/interfaces';
import {
  isCurrentScreenWithCOD,
  isCurrentScreenWithCODThankYou,
  isCurrentScreenWithDYR,
  lang,
} from 'src/utils';

import { IScheduledSectionComponent } from '../../ScheduleComponentPage.interface';

export const getScreenMessageAndType = (
  layout: ILayout,
  screenIndex: number,
  globalComponentsScreen?: GlobalComponentsScreenInterface,
) => {
  const isOutdoorType = layout.layout_type_id === LayoutTypeIds.OUTDOOR;

  if (
    isOutdoorType &&
    (isCurrentScreenWithCOD(screenIndex + 1, globalComponentsScreen) ||
      isCurrentScreenWithCODThankYou(screenIndex + 1, globalComponentsScreen) ||
      isCurrentScreenWithDYR(screenIndex + 1, globalComponentsScreen))
  ) {
    return {
      type: 'warning',
      message: lang.scheduleComponent.outdoorDynamicScreenAlert,
    };
  }

  return {
    type: 'info',
    message: lang.editLayoutsSidebar.createSectionAlert,
  };
};

export function formatAssemblyComponents(
  assemblyComponents: IScheduledSectionComponent[],
) {
  const scheduleComponents = assemblyComponents.flatMap((item) => {
    const { backups, ...components } = item;

    return [components, ...(backups ?? [])];
  });

  return scheduleComponents;
}
